import React from 'react';
import { FormInstance } from 'antd';
import DockConfigurationField from './dock-configuration-field';
import { formFields, dangerousGoodFields, addressFormFields } from 'components/create-consignment/create-modal.constants';
import ContentTypeField from './piece-field/content-type';
import CommodityNameField from './piece-field/commodity-name';
import NumPiecesField from './num-pieces';
import WeightField from './weight';
import DimensionsField from './dimensions';
import PieceReferenceNumber from './piece-field/piece-reference-number';
import GenericField from './generic-field';
import DescriptionField from './description';
import RiskField from './risk-surcharge';
import DeclaredValueField from './declared-value';
import DangerousGoodSubLayoutFields from './dangerous-good-generic';
import DangerousGoodUnNumberField from './dangerous-good-un-number';
import ItemUnit from './piece-field/item-unit';
import QuantityField from './piece-field/quantity';
import CodAmount from './cod-amount';
import piecesItemDetailsFields from './pieces-item-details';
import PurchaseOrderNumberField from './piece-field/purchase-order-number';
import DangerousGoodFields from './dangerous-good-renderer';
import ProductCodeField from './piece-field/product-code';
import ImageListUpload from './image-list-upload';

const {
    ContentTypes,
    ContentNameForOthers,
    NumPieces,
    Weight,
    DeclaredValue,
    ReferenceNumber,
    Vol_weight,
    Description,
    RiskSurcharge,
    ItemUnitType,
    Amount,
    Quantity,
    TaxPercentage,
    TotalTax,
    ManufacturingCountry,
    MEIS,
    PurchaseOrderNumber,
    Eccn,
    IsKit,
    PieceProductCode,
    HsCode,
    IossCode,
    IGST,
    CGST,
    SGST,
    TaxDetailsRecieverGstin,
    TaxDetailsSenderGstin,
    ForwardReferenceNumber,
    InvoiceNumber,
    InvoiceStatus,
    InvoiceDate,
    InvoiceAmount,
    EwbNumber,
    SenderGstin,
    ReceiverGstin,
    EwbCreationTime,
    EwbExpiryTime,
    TransporterGstin,
    TransporterName,
    ProofImageList,
    ProductFamily,
    ProductCategory,
    BrandName,
} = formFields;

const {
    DangerousGoodCategoryPackingInstruction,
    DangerousGoodCategoryType,
    DangerousGoodCategory,
    DangerousGoodPackingGroup,
    DangerousGoodAccessible,
    DangerousGoodUnNumber,
    IsDangerousGood,
} = dangerousGoodFields;

const {
    Name,
    Phone,
    AlternatePhone,
    AlternatePhone2,
    Email,
    CompanyName,
    AddressLine1,
    AddressLine2,
    AddressLine3,
    AddressLine4,
    AddressLine5,
    Pincode,
    CityName,
    StateName,
    CountryName,
    District,
    Latitude,
    Longitude,
    AddressType,
    ServiceTime,
    TimeSlotList,
    DockConfiguration,
} = addressFormFields;

const pieceFieldsMapping = {
    [ContentTypes.key]: ContentTypeField,
    [ItemUnitType.key]: ItemUnit,
    [Amount.key]: CodAmount,
    [Quantity.key]: QuantityField,
    [ContentNameForOthers.key]: CommodityNameField,
    [ReferenceNumber.key]: PieceReferenceNumber,
    [NumPieces.key]: NumPiecesField,
    [Weight.key]: WeightField,
    dimensions: DimensionsField,
    [DeclaredValue.key]: DeclaredValueField,
    piecesItem: piecesItemDetailsFields,
    [RiskSurcharge.key]: (props: any) => {
        return <RiskField field={RiskSurcharge} {...props} />;
    },
    [Description.key]: DescriptionField,
    [MEIS.key]: (props: any) => {
        return <GenericField field={MEIS} {...props} />;
    },
    [PurchaseOrderNumber.key]: PurchaseOrderNumberField,
    [Eccn.key]: (props: any) => {
        return <GenericField field={Eccn} {...props} />;
    },
    [PieceProductCode.key]: (props: any) => {
        return <ProductCodeField field={PieceProductCode} {...props} />;
    },
    [HsCode.key]: (props: any) => {
        return <GenericField field={HsCode} {...props} />;
    },
    [IossCode.key]: (props: any) => {
        return <GenericField field={IossCode} {...props} />;
    },
    [IsKit.key]: (props: any) => {
        return <GenericField field={IsKit} {...props} />;
    },
    dangerousGood: (props: any) => {
        return <DangerousGoodFields {...props} />;
    },
    [ManufacturingCountry.key]: (props: any) => {
        const { params } = props;
        const { manufacturingCountryList } = params;
        params.enableCustomFilter = true;
        return (
            <GenericField
                field={
                    {
                        ...ManufacturingCountry,
                        options: manufacturingCountryList || [],
                    }
                }
                {...props}
            />
        );
    },
    [TotalTax.key]: (props: any) => {
        return (
            <GenericField
                field={TotalTax}
                {...props}
            />
        );
    },
    [TaxPercentage.key]: (props: any) => {
        return (
            <GenericField
                field={TaxPercentage}
                MAX_LIMIT={100}
                {...props}
            />
        );
    },
    [IGST.key]: (props: any) => {
        return (
            <GenericField {...props} field={IGST} MAX_LIMIT={100} />
        );
    },
    [CGST.key]: (props: any) => {
        return (
            <GenericField {...props} field={CGST} MAX_LIMIT={100} />
        );
    },
    [SGST.key]: (props: any) => {
        return (
            <GenericField {...props} field={SGST} MAX_LIMIT={100} />
        );
    },
    [TaxDetailsRecieverGstin.key]: (props: any) => {
        return (
            <GenericField {...props} field={TaxDetailsRecieverGstin} />
        );
    },
    [TaxDetailsSenderGstin.key]: (props: any) => {
        return (
            <GenericField {...props} field={TaxDetailsSenderGstin} />
        );
    },
    [ForwardReferenceNumber.key]: (props: any) => {
        return (
            <GenericField {...props} field={ForwardReferenceNumber} />
        );
    },
    [ProductCategory.key]: (props: any) => {
        return (
            <GenericField {...props} field={ProductCategory} />
        );
    },
    [ProductFamily.key]: (props: any) => {
        return (
            <GenericField {...props} field={ProductFamily} />
        );
    },
    [BrandName.key]: (props: any) => {
        return (
            <GenericField {...props} field={BrandName} />
        );
    },
};

const documentFieldMapping = {
    [Weight.key]: WeightField,
    [Description.key]: DescriptionField,
    [ContentTypes.key]: ContentTypeField,
    [ContentNameForOthers.key]: CommodityNameField,
    [ReferenceNumber.key]: PieceReferenceNumber,
    [NumPieces.key]: NumPiecesField,
    dimensions: DimensionsField,
    [DeclaredValue.key]: DeclaredValueField,
    [RiskSurcharge.key]: (props: any) => {
        return <RiskField field={RiskSurcharge} {...props} />;
    },
};

const envelopeFieldMapping = {
    [Weight.key]: WeightField,
    [Description.key]: DescriptionField,
    [ContentTypes.key]: ContentTypeField,
    [ContentNameForOthers.key]: CommodityNameField,
    [ReferenceNumber.key]: PieceReferenceNumber,
    [NumPieces.key]: NumPiecesField,
    dimensions: DimensionsField,
    [DeclaredValue.key]: DeclaredValueField,
    [RiskSurcharge.key]: (props: any) => {
        return <RiskField field={RiskSurcharge} {...props} />;
    },
};

const boxDetailsFieldMapping = {
    [NumPieces.key]: NumPiecesField,
    [Weight.key]: WeightField,
    dimensions: DimensionsField,
    [DeclaredValue.key]: (props: any) => {
        return <GenericField field={DeclaredValue} {...props} />;
    },
    [Vol_weight.key]: (props: any) => {
        return <GenericField field={Vol_weight} {...props} />;
    },
    [Description.key]: DescriptionField,
};

const dangerousGoodFieldMapping = {
    [IsDangerousGood.key]: (props: any) => {
        return <DangerousGoodSubLayoutFields field={IsDangerousGood} {...props} />;
    },
    [DangerousGoodUnNumber.key]: (props: any) => {
        return <DangerousGoodUnNumberField {...props} />;
    },
    [DangerousGoodAccessible.key]: (props: any) => {
        return <DangerousGoodSubLayoutFields field={DangerousGoodAccessible} {...props} />;
    },
    [DangerousGoodCategoryType.key]: (props: any) => {
        return <DangerousGoodSubLayoutFields field={DangerousGoodCategoryType} {...props} />;
    },
    [DangerousGoodCategoryPackingInstruction.key]: (props: any) => {
        return <DangerousGoodSubLayoutFields field={DangerousGoodCategoryPackingInstruction} {...props} />;
    },
    [DangerousGoodCategory.key]: (props: any) => {
        return <DangerousGoodSubLayoutFields field={DangerousGoodCategory} {...props} />;
    },
    [DangerousGoodPackingGroup.key]: (props: any) => {
        return <DangerousGoodSubLayoutFields field={DangerousGoodPackingGroup} {...props} />;
    },
};

const invoiceFieldsMapping = {
    [ReferenceNumber.key]: (props: any) => {
        return <PieceReferenceNumber invoiceTypeField {...props} />;
    },
    [InvoiceDate.key]: (props: any) => {
        return <GenericField field={InvoiceDate} {...props} />;
    },
    [InvoiceNumber.key]: (props: any) => {
        return <GenericField field={InvoiceNumber} {...props} />;
    },
    [InvoiceStatus.key]: (props: any) => {
        return <GenericField field={InvoiceStatus} {...props} />;
    },
    [InvoiceAmount.key]: (props: any) => {
        return <GenericField field={InvoiceAmount} {...props} />;
    },
    [EwbNumber.key]: (props: any) => {
        return <GenericField field={EwbNumber} {...props} />;
    },
    [SenderGstin.key]: (props: any) => {
        return <GenericField field={SenderGstin} {...props} />;
    },
    [ReceiverGstin.key]: (props: any) => {
        return <GenericField field={ReceiverGstin} {...props} />;
    },
    [EwbCreationTime.key]: (props: any) => {
        return <GenericField field={EwbCreationTime} {...props} />;
    },
    [EwbExpiryTime.key]: (props: any) => {
        return <GenericField field={EwbExpiryTime} {...props} />;
    },
    [TransporterGstin.key]: (props: any) => {
        return <GenericField field={TransporterGstin} {...props} />;
    },
    [TransporterName.key]: (props: any) => {
        return <GenericField field={TransporterName} {...props} />;
    },
    [ProofImageList.key]: (props: any) => {
        const { params, form } = props;
        return (
            <ImageListUpload params={params} form={form} isPieceLevel={false} />
        );
    },
};


const addressFieldsMapping = {
    [Name.key]: (props: any) => {
        return <GenericField field={Name} {...props} />;
    },
    [Phone.key]: (props: any) => {
        return <GenericField field={Phone} {...props} />;
    },
    [AlternatePhone.key]: (props: any) => {
        return <GenericField field={AlternatePhone} {...props} />;
    },
    [AlternatePhone2.key]: (props: any) => {
        return <GenericField field={AlternatePhone2} {...props} />;
    },
    [Email.key]: (props: any) => {
        return <GenericField field={Email} {...props} />;
    },
    [CompanyName.key]: (props: any) => {
        return <GenericField field={CompanyName} {...props} />;
    },
    [AddressLine1.key]: (props: any) => {
        return <GenericField field={AddressLine1} {...props} />;
    },
    [AddressLine2.key]: (props: any) => {
        return <GenericField field={AddressLine2} {...props} />;
    },
    [AddressLine3.key]: (props: any) => {
        return <GenericField field={AddressLine3} {...props} />;
    },
    [AddressLine4.key]: (props: any) => {
        return <GenericField field={AddressLine4} {...props} />;
    },
    [AddressLine5.key]: (props: any) => {
        return <GenericField field={AddressLine5} {...props} />;
    },
    [Pincode.key]: (props: any) => {
        return <GenericField field={Pincode} {...props} />;
    },
    [CityName.key]: (props: any) => {
        return <GenericField field={CityName} {...props} />;
    },
    [StateName.key]: (props: any) => {
        return <GenericField field={StateName} {...props} />;
    },
    [CountryName.key]: (props: any) => {
        return <GenericField field={CountryName} {...props} />;
    },
    [District.key]: (props: any) => {
        return <GenericField field={District} {...props} />;
    },
    [Latitude.key]: (props: any) => {
        return <GenericField field={Latitude} {...props} />;
    },
    [Longitude.key]: (props: any) => {
        return <GenericField field={Longitude} {...props} />;
    },
    [AddressType.key]: (props: any) => {
        return <GenericField field={AddressType} {...props} />;
    },
    [ServiceTime.key]: (props: any) => {
        return <GenericField field={ServiceTime} {...props} />;
    },
    [TimeSlotList.key]: (props: any) => {
        return <GenericField field={TimeSlotList} {...props} />;
    },
    [DockConfiguration.key]: (props: any) => {
        return <DockConfigurationField {...props} />;
    },
};

const getMapping = (
    id: any,
    form: FormInstance,
    params: any,
    Component: any,
    shouldNotMakeItemTypeCheck: boolean = false,
) => {
    if (Component) {
        const { parentObj, ...restParams } = params;
        return (
            <Component
                form={form}
                params={restParams}
                parentObj={parentObj}
                shouldNotMakeItemTypeCheck={shouldNotMakeItemTypeCheck}
            />
        );
    }
    return null;
};

export const getPieceLevelFieldFromMapping = (id: any, form: FormInstance, params: any) => {
    return getMapping(id, form, params, pieceFieldsMapping[id]);
};

export const getDocumentFieldFromMapping = (id: any, form: FormInstance, params: any) => {
    return getMapping(id, form, params, documentFieldMapping[id], true);
};

export const getEnvelopeFieldFromMapping = (id: any, form: FormInstance, params: any) => {
    return getMapping(id, form, params, envelopeFieldMapping[id], true);
};

export const getBoxLevelFieldFromMapping = (id: any, form: FormInstance, params: any) => {
    return getMapping(id, form, params, boxDetailsFieldMapping[id]);
};

export const getDangerousGoodFieldFromMapping = (id: any, form: FormInstance, params: any) => {
    return getMapping(id, form, params, dangerousGoodFieldMapping[id]);
};

export const getInvoiceLevelFieldFromMapping = (id: any, form: FormInstance, params: any) => {
    return getMapping(id, form, params, invoiceFieldsMapping[id], true);
};

export const getAddressFieldFromMapping = (id: string, form: FormInstance, params: any) => {
    return getMapping(id, form, params, addressFieldsMapping[id]);
};
